import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Avatar, Button, Flex, Space} from "antd";
import Title from "antd/es/typography/Title";
import {fetchContributors, updateContributor} from "../../feature/project/userSlice";
import React from "react";

export const Invitation = (props: any) => {
    const dispatch = useAppDispatch()
    const project = useAppSelector(state => state.projects.project);
    const user = useAppSelector(state => state.users.currentUser);
    const contributors = useAppSelector(state => state.users.contributors);
    const [decline, setDecline] = React.useState(false)
    const [accept, setAccept] = React.useState(false)
    return (
        <Flex vertical={true} justify={'center'} align={'center'}>
            <Avatar size={128} src={project?.icon}/>
            <Title level={3}>{project?.title}</Title>
            <Title level={5}>You have invitation into this project</Title>
            <Space>
                <Button
                    loading={decline}
                    type={'default'}
                    onClick={() => {
                        const contributor = contributors.find(contributor => contributor.id === user?.id)
                        if (contributor && project && user) {
                            setDecline(true)
                            dispatch(updateContributor({
                                ...contributor,
                                projectId: project?.id,
                                userId: user?.id,
                                status: 'inactive'
                            })).then(() =>
                                dispatch(fetchContributors(project?.id))
                            ).finally(() => {
                                setDecline(false)
                            })
                        }
                    }}
                >Decline</Button>
                <Button
                    loading={accept}
                    type={'primary'}
                    onClick={() => {
                        const contributor = contributors.find(contributor => contributor.id === user?.id)
                        if (contributor && project && user) {
                            setAccept(true)
                            dispatch(updateContributor({
                                ...contributor,
                                projectId: project?.id,
                                userId: user?.id,
                                status: 'active'
                            })).then(() =>
                                dispatch(fetchContributors(project?.id))
                            ).finally(() => {
                                setAccept(false)
                            })
                        }
                    }}
                >Accept</Button>
            </Space>
        </Flex>
    )
}